import { ImageLoader } from "./renderer/util/image-loader";

export const USER_SIZE = 5;

export const DEVICE_PIXEL_RATIO = typeof devicePixelRatio === "undefined" ? 1 : devicePixelRatio;

export const DBL_CLICK_SPEED_MS = 300;

export const FONT_SIZE = 3;

export const NODE_PADDING = 3;

export const IMAGE_LOADER = new ImageLoader();

export const MAX_SCALE = 9;
export const MIN_SCALE = 0.5;

export const FOLLOW_USER_SCALE = 10;

export const MIN_ALPHA = 0.01;

export const TARGET_ALPHA = 0;
export const TARGET_ALPHA_REPACKING = 0.3;
// const TARGET_ALPHA_DRAGGING = 0.03;
// export const TARGET_ALPHA_DRAGGING = 0.02;
export const TARGET_ALPHA_DRAGGING = 0.2;
// export const TARGET_ALPHA_RESYNCING = 0.02;
export const TARGET_ALPHA_RESYNCING = 0.1;

// export const ALPHA_DECAY = 0.02;
export const ALPHA_DECAY = 0.05;
export const ALPHA_DECAY_REPACKING = 0;

export const VELOCITY_DECAY = 0.4;
// export const VELOCITY_DECAY = 0.4;
// const VELOCITY_DECAY_REPACKING = 0.3;
export const VELOCITY_DECAY_REPACKING = 0.1 * 2;
export const VELOCITY_DECAY_DRAGGING = 0.3;

export const RECENTER_PADDING_SCALE_PERCENTAGE = 0.3;
export const RECENTER_PADDING_PADDING_LEFT = 0;
export const RECENTER_PADDING_PADDING_TOP = 0;
